import React, { FC } from 'react';

interface IProps {
  color?: string;
  onClick?: React.MouseEventHandler<SVGSVGElement> | undefined;
  className?: string;
  pathProps?: React.SVGProps<SVGPathElement>;
  size?: number;
  mode?: 'bold' | 'stroke';
}

const LikeIcon: FC<IProps> = ({ color = '#000000', onClick, className, size = 16, pathProps, mode }) =>
  mode === 'stroke' ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M4.98682 12.2332L7.05348 13.8331C7.32015 14.0998 7.92015 14.2331 8.32015 14.2331H10.8535C11.6535 14.2331 12.5202 13.6331 12.7202 12.8331L14.3202 7.96648C14.6535 7.03315 14.0535 6.23315 13.0535 6.23315H10.3868C9.98682 6.23315 9.65348 5.89982 9.72015 5.43315L10.0535 3.29982C10.1868 2.69982 9.78682 2.03315 9.18682 1.83315C8.65348 1.63315 7.98682 1.89982 7.72015 2.29982L4.98682 6.36648"
        stroke="currentColor"
        strokeMiterlimit="10"
        {...pathProps}
      />
      <path
        d="M1.58643 12.2331V5.69977C1.58643 4.76644 1.98643 4.43311 2.91976 4.43311H3.58643C4.51976 4.43311 4.91976 4.76644 4.91976 5.69977V12.2331C4.91976 13.1664 4.51976 13.4998 3.58643 13.4998H2.91976C1.98643 13.4998 1.58643 13.1664 1.58643 12.2331Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...pathProps}
      />
    </svg>
  ) : (
    <svg
      className={className}
      onClick={onClick}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.39001 18.4902V8.33022C8.39001 7.93022 8.51001 7.54022 8.73001 7.21022L11.46 3.15022C11.89 2.50022 12.96 2.04022 13.87 2.38022C14.85 2.71022 15.5 3.81022 15.29 4.79022L14.77 8.06022C14.73 8.36022 14.81 8.63022 14.98 8.84022C15.15 9.03022 15.4 9.15022 15.67 9.15022H19.78C20.57 9.15022 21.25 9.47022 21.65 10.0302C22.03 10.5702 22.1 11.2702 21.85 11.9802L19.39 19.4702C19.08 20.7102 17.73 21.7202 16.39 21.7202H12.49C11.82 21.7202 10.88 21.4902 10.45 21.0602L9.17001 20.0702C8.68001 19.7002 8.39001 19.1102 8.39001 18.4902Z"
        fill={color}
        {...pathProps}
      />
      <path
        d="M5.21 6.37988H4.18C2.63 6.37988 2 6.97988 2 8.45988V18.5199C2 19.9999 2.63 20.5999 4.18 20.5999H5.21C6.76 20.5999 7.39 19.9999 7.39 18.5199V8.45988C7.39 6.97988 6.76 6.37988 5.21 6.37988Z"
        fill={color}
        {...pathProps}
      />
    </svg>
  );

export default LikeIcon;
